import * as postFiniteActions from '../../action_creators/post/post_finite_action_creators';
import PostFiniteModel from '../../../models/post/post_finite_module';
import log from '../../../services/logger_service';
// import { setAB } from '../../../utils/ab_test_util';

export default function fetchPostDetail(dispatch, id, advertorialTag, config) {
  dispatch(postFiniteActions.postFiniteLoading());
  return PostFiniteModel.fetch(id, advertorialTag, config)
    .then(function handlePostDetailData(resp) {
      // const state = store.getState();
      // const abtest = state.config.abtest

      const { data } = resp;
      // Object.keys(data).forEach(key => {
      //   if (Array.isArray(data[key])) {
      //     setAB(data[key],abtest);
      //   }
      // });

      dispatch(postFiniteActions.postFiniteLoaded(data));
    })
    .catch(function handleUserError(err) {
      dispatch(postFiniteActions.postFiniteLoadError(err));
      log.error(err, `Error in post finite actions, message: ${err.message}`);
    });
}
